import { render, staticRenderFns } from "./desktoporderhistory.vue?vue&type=template&id=4489fd4f&"
import script from "./desktoporderhistory.vue?vue&type=script&lang=js&"
export * from "./desktoporderhistory.vue?vue&type=script&lang=js&"
import style0 from "./desktoporderhistory.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports